import { PureComponent } from "react";
import PropTypes from "prop-types";
import { Card } from "semantic-ui-react";

import DraggableFlowCard from "../draggable/DraggableFlowCard";

class InnerFlowItemsList extends PureComponent {
  render() {
    const { items, onRemoveItemClick } = this.props;

    return (
      <Card.Group>
        {items.map((item, index) => (
          <DraggableFlowCard key={item.id} {...item} index={index} onRemoveItemClick={onRemoveItemClick} />
        ))}
      </Card.Group>
    );
  }
}

InnerFlowItemsList.propTypes = {
  items: PropTypes.array.isRequired,
  onRemoveItemClick: PropTypes.func.isRequired,
};

export default InnerFlowItemsList;
